import { useState, useEffect } from "react";
import { instance } from "./axiosBase";

const ApiKEY = "AIzaSyB5QsRiXOQGtvzu7oWA7imVQKmS5PDUsDs";
const useYoutubeSearch = (query) => {
  const [data, setData] = useState(null);

  useEffect(() => {
    const fetch = async () => {
      await instance
        .get(`${query}&key=${ApiKEY}`)
        .then((data) => setData(data.data))
        .catch((err) => console.log("Error in Fetch data from Youtube", err));
    };
    fetch();
  }, [query]);

  return data;
};

export { useYoutubeSearch };
// search==>>> https://youtube.googleapis.com/youtube/v3/search?part=snippet&maxResults=50&q=surfing&key=AIzaSyB5QsRiXOQGtvzu7oWA7imVQKmS5PDUsDs
